const defaultSettings = {
    version: 0.2,
    downloadCount: 0,
    labels: [
        {
            labelId: 0,
            name: 'Tree'
        }
    ],
    selectedLabel: 0,
    outputDimension: [640, 640],
    displayOutputDimension: true,
    width: '640px',
    height: '640px',
    center: [1187792.9370239673,6013459.583724894],
    zoom: 8,
    minZoom: 18,
    maxZoom: 19,
    foreground: {
        center: [1187792.9370239673,6013459.583724894],
        zoom: 18,
        extents: []
    },
    background: {
        center: [1187792.9370239673,6013459.583724894],
        zoom: 18,
        extents: []
    },
    output: {
        imagesToGenerate: 100,
        minZoom: 19,
        maxZoom: 20,
        syntaticCount: 10,
        minRotation: 0,
        maxRotation: 360,
        minScale: 80,
        maxScale: 120,
        randomBackground: true,

        brightnessMin: 50,
        brightnessMax: 150,
        contrastMin: 100,
        contrastMax: 100,
        saturationMin: 100,
        saturationMax: 100,
        blur: 0,
        hueRotateMin: 0,
        hueRotateMax: 0,
        basemapsSelected: [],
    },
    basemaps: [
        {
            name: 'Google Maps',
            subtitle: '(World)',
            id: 'google',
            host: ['https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'],
            maxZoom: 21,
            selected: true,
            attributions: '© Google Maps'
        },
        {
            name: 'Arcgis World Imagery',
            subtitle: '(World)',
            id: 'esri',
            host: ['https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
            maxZoom: 19,
            selected: false,
            attributions: '© Esri, DigitalGlobe, GeoEye, i-cubed, USDA, USGS, AEX, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community'
        },
    ]
}

const saveSettings = (json) => {
    localStorage.setItem('mapSenseSettings', JSON.stringify(json));
}
const removeSettings = () => {
    localStorage.removeItem('mapSenseSettings');
}
const loadSettings = () => {
    let settings;
    try {
        const settingsStr = localStorage.getItem('mapSenseSettings');
        const settingsObj = JSON.parse(settingsStr);
        if(!settingsObj.version || settingsObj.version < defaultSettings.version) return settings = defaultSettings;
        return settings = settingsObj;
    }
    catch (err) {
        return defaultSettings;
    }
    finally {
        return settings || defaultSettings;
    }
}

export {saveSettings, loadSettings, removeSettings};